import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addReportCategory,
  deleteReportCategory,
  getReportCategory,
  updateDefaultReportCategory,
  updateReportCategory,
} from "store/services/dataManagement/category";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllReportCategoriesAction = createAsyncThunk(
  "reportCategories/get",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getReportCategory(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  },
);

export const DeleteReportCategoryAction = createAsyncThunk(
  "reportCategories/delete",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const { filter, onSuccess, onError, ...rest } = payload;
      const res = await deleteReportCategory(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        const responce = await getReportCategory(filter);
        if (responce.status === 1) {
          if(onSuccess) onSuccess();
          
          return fulfillWithValue(responce);
        }
      }
      if(onError) onError();
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  },
);

export const UpdateReportCategoryAction = createAsyncThunk(
  "reportCategories/update",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { onSuccess, onError, ...rest } = payload;
    try {
      const res = await updateReportCategory(rest);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      if (onError) {
        onError();
      }
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

export const AddReportCategoryAction = createAsyncThunk(
  "reportCategories/add",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    const { filter, onSuccess, onError, ...rest } = payload;
    try {
      // if any async operation need to be done on response data, do it here,
      // then full fill data
      const res = await addReportCategory(rest);
      if (res.status === 1) {
        if (onSuccess) {
          onSuccess();
        }
        dispatch(closeAdminModal());
        const responce = await getReportCategory(filter);
        if (responce.status === 1) {
          return fulfillWithValue(responce);
        }
      }
      if (onError) {
        onError();
      }
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        }),
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      if (onError) {
        onError();
      }
      return rejectWithValue(error);
    }
  },
);

export const UpdateDefaultReportCategoryAction = createAsyncThunk(
  "reportCategories/updateDefault",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await updateDefaultReportCategory(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) }),
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        }),
      );
      return rejectWithValue(error);
    }
  },
);
